<template>
  <div class="card-bottom-container" :class="{small}">
    <div class="card-bottom">
      <slot name="left">
        <div />
      </slot>
      <slot name="middle">
        <div />
      </slot>
      <slot name="right">
        <div />
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalCardBottom',
  props: {
    small: {
      type: Boolean,
      defaut: false,
    },
  },
};
</script>

<style scoped>
.card-bottom-container {
  width: 100%;
  padding-top: 8px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
}

.card-bottom-container.small {
  padding-top: 4px;
  padding-bottom: 8px;
}

.card-bottom {
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: space-between;
}
</style>
